const Constants = {
  TINY_LIST_PAGE_SIZE: 5,
  SMALL_LIST_PAGE_SIZE: 6,
  MEDIUM_PAGE_SIZE: 10,
  Countries: {
    ARGENTINA: 'ARG'
  },
  Currencies: {
    ARS: 'ARS',
    USD: 'USD',
    UYU: 'UYU'
  },
  FIRST_PAGE: 1
};

export default Constants;
